import { Users, Award, Globe, BookOpen } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export const Features = () => {
    const { t } = useLanguage();

    const features = [
        {
            icon: Users,
            title: t('home.features.expertSecretariat'),
            description: t('home.features.expertSecretariatDesc')
        },
        {
            icon: Award,
            title: t('home.features.academicExcellence'),
            description: t('home.features.academicExcellenceDesc')
        },
        {
            icon: Globe,
            title: t('home.features.globalPerspective'),
            description: t('home.features.globalPerspectiveDesc')
        },
        {
            icon: BookOpen,
            title: t('home.features.educationalGrowth'),
            description: t('home.features.educationalGrowthDesc')
        }
    ];

    return (
        <section className="py-24 bg-background">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <p className="text-accent font-semibold text-sm uppercase tracking-wider mb-3">
                        {t('home.features.subtitle')}
                    </p>
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-foreground mb-4 gold-underline">
                        {t('home.features.title')}
                    </h2>
                    <p className="text-muted-foreground text-lg max-w-2xl mx-auto mt-8">
                        {t('home.features.description')}
                    </p>
                </div>

                {/* Features Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="group p-8 rounded-xl bg-card border border-border hover:border-accent/30 transition-all duration-300 hover:shadow-elegant-lg"
                            style={{ animationDelay: `${index * 100}ms` }}
                        >
                            <div className="w-14 h-14 rounded-lg bg-accent/10 flex items-center justify-center mb-6 group-hover:bg-accent/20 transition-colors">
                                <feature.icon className="w-7 h-7 text-accent" />
                            </div>
                            <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;
